<template>
    <div class="dashboard-order-box p-3 border border-dark d-flex flex-column justify-content-center" :class="preparationBgClass(preparationStatus.color) + ' ' + boxClass">
        <div class="h2 mb-0 text-ellipsis">
            <small>
                <OrderIcon v-if="type && (type === 'pickup_point_subcustomer' || type === 'short_channel' || type === 'customer_group')" :type="type" :online="online"></OrderIcon>
                <MissingProductsIcon v-if="preparationStatus.preparation_counters.nb_missing > 0"></MissingProductsIcon>
            </small>
            {{ name }}
        </div>
        <div class="h1 mb-0">
            {{ preparationStatus.numerator }}
            <small v-if="preparationStatus.preparation_counters.nb_toremove > 0">
                + {{ preparationStatus.preparation_counters.nb_toremove }}
            </small>
            / {{ preparationStatus.denominator }}
        </div>
    </div>
</template>

<script>
    import MissingProductsIcon from "../../Preparation/MissingProductsIcon";
    import OrderIcon from "../../Preparation/OrderIcon"
    import {preparationBgClass} from "../../../preparation-classes";

    export default {
        name: 'DashboardOrderBox',

        components: {
            MissingProductsIcon,
            OrderIcon,
        },

        props: {
            boxClass: {
                type: String,
                required: false,
            },
            id: {
                type: Number,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                required: false,
                default: null,
            },
            online: {
                type: Boolean,
                required: false,
                default: false,
            },
            preparationStatus: {
                type: Object,
                required: true,
            },
        },

        methods: {
            preparationBgClass,
        },
    }
</script>

<style lang="scss" scoped>
    .dashboard-order-box {
    }
</style>
